export const LOG_PREFIX = '[browser-storage-controls]';

// Throttling for operational error events (COOK-515). Keyed per event action.
// High-volume errors (e.g. loadStorageControlsError) could otherwise emit millions of
// effectively-duplicate operational events per day.
export const ERROR_EVENT_THROTTLE_INTERVAL_MS = 5000; // min gap between sends of the same action
export const ERROR_EVENT_MAX_PER_SESSION = 10; // hard cap per action per page load
